export interface TrimDescription {
  id: string;
  key: string;
  description: string;
}
